<template>
  <div id="importExamZIP">
    <template v-if="isImportExamZIP">

    <ots-main-title :mainTopBtn="mainTopBtn"></ots-main-title>
    <div class="mainCon mainBox">
      <el-form>
        <div style="display:flex; flex-wrap: wrap;">
        <el-form-item label="考试批次：" style="margin-right: 16px;">
          <el-select v-model="planId" placeholder="请选择" filterable>
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考点：" style="margin-right: 16px;">
          <el-select v-model="placeId" placeholder="请选择" filterable>
            <el-option v-for="item in placeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="教室：" style="margin-right: 16px;">
          <el-select v-model="classId" placeholder="请选择" filterable>
            <el-option v-for="item in classData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="场次：" >
          <el-select v-model="sessionId" placeholder="请选择" filterable>
            <el-option v-for="item in sessionList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        </div>
        <!-- 导入数据包 -->
        <el-form-item label="压缩包（zip）：">
          <el-upload
            action=""
            ref="upload"
            :multiple="multiple"
            :limit="limit"
            :http-request="httpRequest"
            :show-file-list="true"
            :before-upload="beforeUpload"
          >
            <template v-if="isHasSlot">
              <slot></slot>
            </template>
            <div v-else class="default-upload-container">{{ getFileName }}</div>
          </el-upload>
        </el-form-item>

        <el-button type="primary" round plain @click="importZip" style="margin-top: 16px;"> 上传考试结果 </el-button>
        <el-button type="primary" round plain @click="importBackups" style="margin-top: 16px;"> 上传考试备份 </el-button>
        <el-button type="primary" round @click="search" style="margin-top: 16px;"> 查询 </el-button>
        
        <p style="margin-top: 24px; color: #FE5859; font-weight: 700;"> 备注： </p>
        <p style="margin-top: 8px; color: #FE5859;"> 1、纯断网考试模式下，上传完考试结果后才可查看考生作答记录。 </p>
        <p style="margin-top: 8px; color: #FE5859;"> 2、纯断网考试模式下，上传完考试备份后才可查看考生考试轨迹详情。 </p>
      </el-form>
    </div>

    <ots-table-group-new
      :tableHeader="tableHeader"
      :tableData="tableData"
      :pagination="pagination"
      @changeNum="changeSize"
      @changePage="changePage"
    ></ots-table-group-new>

    <ots-custom-dialog :dialog.sync="ExamResultsDialog" title="上传结果">
      <template v-slot:content>
        <div>
          <div v-for="(item, key) in examResultData" :key="key" style="margin-bottom: 16px;">
            <!-- <h3 style="margin-bottom: 8px;">{{item.fileName}}</h3> -->
            <p>{{item.msg}}</p>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round type="primary" @click="ExamResultsDialog = false">确定</el-button>
      </template>
    </ots-custom-dialog>


    </template>

    <template v-else>
      <router-view></router-view>
    </template>

  </div>
</template>

<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import { getSelectPlace } from "@/http/modules/baseSet/examSite";
import { uploadExamPackageByBatchAPI, queryExamSubmitNumAPI, uploadExamDataBakByBatchAPI, getSelectClassAPI, exprotExamSubmitNumAPI } from "@/http/modules/computedRoomExam";
import { getPlanAllSessionByPlan } from "@/http/modules/examSet/planClass";


export default {
  name: "importExamZIP", 
  data() {
    return {
      options: [],
      planId: '',
      mainTopBtn: [
         {
          title: '导出',
          plain: true,
          fn: this.Export
        },        
      ],
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
      ],

      // 导入文件相关
      multiple: false,
      limit: 1,
      file: "",
      name: "点击选择文件",
      fileType: "zip",

      tableHeader: [
        {
          title: "批次名称",
          prop: "planName",
        },
        {
          title: "考点",
          prop: "placeName"
        },
        {
          title: "教室",
          prop: "className"
        },
        {
          title: "场次",
          prop: "sessionName"
        },
        {
          title: "回收试卷数",
          prop: "returnAnswerNum"
        },
        // {
        //   title: "交卷数",
        //   prop: "submitOtsAnswerNum"
        // },
        {
          title: "交卷成功数",
          prop: "submitOtsSuccessNum"
        },
        {
          title: "交卷失败数",
          prop: "submitOtsFailedNum"
        },
        {
          title: "OTS阅卷成绩回传数",
          prop: "setScoreByOTSNum"
        },
        {
          title: "操作",
          type: 'button',
          width: '100',
          formatter: (val) => { return "查看" },
          click: this.show,
          align: 'right'
        }
      ],
      tableData: [],
      currentPlan: {},
      pagination: {
        total: 0,
      },
      ExamResultsDialog: false,
      examResultData:[],

      placeList: [],
      placeId: "",

      classData: [],
      classId: "",

      sessionId: "",
      sessionList: [],

      size: 10,
      page: 1,
    }
  },
  computed: {
    isHasSlot() {
      return this.$slots.default && this.$slots.default.length;
    },
    getFileName() {
      if (this.multiple) {
        let newName = this.name.replace(/点击选择文件/g, "");
        return this.name === "点击选择文件" ? this.name : newName.substring(0, newName.lastIndexOf("、"));
      } else {
        return this.name;
      }
    },
    isImportExamZIP() {
      return this.$route.name === "importExamZIP";
    },
  },
  watch: {
    planId: function(val) {
      for (let key in this.options) {
        if (this.options[key].id == val) {
          this.currentPlan = this.options[key];
          break;
        }
      }
      this.tableData = [];
      this.sessionId = "";
      this.getSessionList();
      this.classId = "";
      this.getClassList();
      this.search();
    },

    placeId: function(val) {
      this.classId = "";
      this.getClassList();
    },

    "$route.path": function (to, from) {
      this.page = 1;
      this.getTableList();
    }

  },
  mounted() {
    this.initData();
  },
  methods: {
    // 上传考试备份
    async importBackups() {
      if (!this.file) {
        this.$message.error("请选择 “ 考试备份 ” 压缩包文件！");
        return;
      }
      const formData = new FormData();
      let params = {
        file: this.file,
        planId: this.planId
      }
      for (let item in params) {
        formData.append(item, params[item]);
      }
      const res = await uploadExamDataBakByBatchAPI(formData);
      if (res.code == 1) { 
        this.$message.success("考试备份上传成功！");
      }
    },
 
    async search() {
      this.page = 1;
      this.getTableList();
      // let params = {
      //   planId: this.planId,
      //   placeId: this.placeId,
      //   classId: this.classId,
      //   sessionId: this.sessionId
      // }
      // const { code, data } = await queryExamSubmitNumAPI(params);
      // if (code == 1) {
      //   data.planName = this.currentPlan.name;
      //   this.tableData = [];
      //   this.tableData.push(data);
      // }
    },


    async getTableList() {
      let params = {
        planId: this.planId,
        placeId: this.placeId,
        classId: this.classId,
        sessionId: this.sessionId,
        size: this.size,
        page: this.page
      }
      const { code, data } = await queryExamSubmitNumAPI(params);
      if (code == 1) {
        this.pagination.total = data.total;
        data.planName = this.currentPlan.name;
        this.tableData = [...data.records];
        // this.tableData.push(data);
      }
    },

    // 初始化数据
    async initData() {
      // 批次
      const { data: planList } = await getSelectPlanFn({needAudit: 32});
      this.options = planList;
      this.planId = planList[0].id;

      // 考点
      const { data: placeList } = await getSelectPlace();
      this.placeList = [{id: '', name: '全部'}, ...placeList];
    },

    // 教室
    async getClassList() {
      let params = {
        planId: this.planId,
        placeId: this.placeId
      }
      const { data: classData } = await getSelectClassAPI(params);
      if (classData.length === 0) {
        this.classData = [];
        this.classId = '';
        return;
      }
      this.classData = [{id: '', name: '全部'}, ...classData];
      this.classId = '';
    },

    async getSessionList() {
      let params = {
        planId: this.planId,
      };
      const { code, data } = await getPlanAllSessionByPlan(params);
      if (code == 1) {
        this.sessionList = [{ id: "", name: "全部" }, ...data];
      } else {
        this.sessionId = '';
        this.sessionList = [{ id: "", name: "全部" }];
      }
    },

    // 执行导入
    async importZip() {
      if (!this.file) {
        this.$message.error("请选择 “ 考试结果 ” 压缩包文件！");
        return;
      }
      const formData = new FormData();
      let params = {
        file: this.file,
        planId: this.planId
      }
      for (let item in params) {
        formData.append(item, params[item]);
      }
      const res = await uploadExamPackageByBatchAPI(formData);
      if (res.code == 1) {
        this.$message.success("机考数据导入成功！");
        this.examResultData = res.data;
        this.ExamResultsDialog = true;
      }
    },
    httpRequest(val) {
      this.file = val.file;
    },
    beforeUpload(file) {
      let isType = true;
      if (this.fileType) {
        isType = file.name.indexOf(this.fileType) > -1;
      }
      const isLimit = Math.floor(file.size / 1024 / 1024) < 10;
      if (!isType) {
        this.$message.error(`只能上传${this.fileType}文件!`);
      } else if (!isLimit) {
        this.$message.error("上传的压缩包文件大小不能超过 10M!");
      }
      let isOk = isType && isLimit;
      if (isOk) {
        this.name = file.name;
      }
      this.$refs.upload.clearFiles();
      return isOk;
    },
    clearFileName() {
      this.name = "点击选择文件";
    },
    show(row) {
      this.$router.push({name: "importExamZIP_Show", query: row})
    },
    changeSize(num) {
      this.size = num;
      this.getTableList();
    },
    changePage(p) {
      this.page = p;
      this.getTableList();
    },
    async Export() {
      let params = {
        planId: this.planId,
        classId: this.classId,
        placeId: this.placeId,
        sessionId: this.sessionId
      }
      const { code, data } = await exprotExamSubmitNumAPI(params);
      if (code) {
        window.open(data);
      }
    },
  }
}
</script>

<style lang="less" scoped>
.default-upload-container {
  box-sizing: border-box;
  width: 240px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #dddddd;
  background: rgba(255, 255, 255, 0.35);
  color: #c2c4cc;
  font-size: 13px;
  line-height: 36px;
  text-align: left;
  padding-left: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/deep/ .el-form-item__content {
  display: flex;
}
</style>